module.exports = __webpack_public_path__ + "static/media/reedEdix916.2954b850.ico";